import React from "react";
import Svg from "./svg";

export default class ReturnIcon extends Svg {
    render() {
        return (
            <svg
                fill={this.props.color}
                className="return-icon"
                width="24"
                height="24"
                enableBackground="new 0 0 512 512"
                version="1.1"
                viewBox="0 0 14.155 14.155"
                xmlSpace="preserve"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink">

                <g>
                    <path d="M 12.083 1.887 c -0.795 -0.794 -1.73 -1.36 -2.727 -1.697 v 2.135 c 0.48 0.24 0.935 0.55 1.334 0.95 c 1.993 1.994 1.993 5.236 0 7.23 c -1.993 1.99 -5.233 1.99 -7.23 0 c -1.99 -1.996 -1.99 -5.236 0 -7.23 c 0.006 -0.006 0.022 -0.016 0.03 -0.025 l 1.182 1.18 L 4.665 0.684 L 0.923 0.68 L 2.1 1.856 c -0.008 0.012 -0.02 0.024 -0.028 0.03 C -0.69 4.65 -0.69 9.13 2.072 11.893 c 2.767 2.765 7.245 2.765 10.01 0 c 2.762 -2.762 2.765 -7.243 0 -10.005 Z" />
                </g>
            </svg>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/svg/reset.js
 **/